import { getPageConfigDataByKey } from '../';
import { StagingLevel } from '../../enums/StagingLevel';

const DEFAULT_STAGING_ENV = StagingLevel.PRODUCTION;
const DEFAULT_IS_NATIVE_APP = false;

export const getStagingEnvironment = (): StagingLevel =>
    getPageConfigDataByKey('stagingEnv', DEFAULT_STAGING_ENV);

export const getInstanceName = (): StagingLevel => getPageConfigDataByKey('instance', '');

export const isStagingEnvironment = (stagingEnv: string): boolean =>
    getStagingEnvironment() === stagingEnv;

export const isInstance = (instance: string): boolean => getInstanceName() === instance;

export const isNativeApp = () =>
    getPageConfigDataByKey('deviceMetaData', {}).isNativeApp || DEFAULT_IS_NATIVE_APP;

export const isUserAgentMobile = () =>
    getPageConfigDataByKey('deviceMetaData', {}).isUserAgentMobile || false;
